// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components----Footer-module---footer---1c9am"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.module.css
// module id = 357
// module chunks = 114276838955818